function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(556.342 8004.28)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.147,26.037h0A1.963,1.963,0,0,1,0,24.257V1.784A1.966,1.966,0,0,1,1.153,0L14.6,13.016,1.148,26.037Zm3.02-.677h0L15.76,14.138l3.107,3.008L4.168,25.36Zm16.169-9.036h0l-3.417-3.308L20.334,9.71l3.1,1.734a1.944,1.944,0,0,1,.022,3.134l-3.123,1.746Z",
  transform: "translate(-556.342 -8004.28)",
  fill: "#1d3054"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0,14.693,8.211l-3.1,3.005Z",
  transform: "translate(-552.17 -8003.602)",
  fill: "#1d3054"
}));

function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.242,
    height: 26.037,
    viewBox: "0 0 24.242 26.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/Playstore.649b1dd5.svg";
export { ForwardRef as ReactComponent };